<button
  [type]="type()"
  [class]="buttonClasses()"
  [disabled]="disabled()"
  (click)="handleClick($event)"
  (focus)="handleFocus($event)"
  (blur)="handleBlur($event)"
  (mouseenter)="handleMouseEnter($event)"
  (mouseleave)="handleMouseLeave($event)"
  (mousedown)="handleMouseDown($event)"
  (mouseup)="handleMouseUp($event)"
  (keydown)="handleKeyDown($event)"
  (keyup)="handleKeyUp($event)"
>
  @if (showLeftIcon()) {
    <v-one-icon
      [name]="icon()"
      [type]="iconType()"
      className="v-one-button__icon v-one-button__icon--left"
    />
  }

  @if (text()) {
    <span class="v-one-button__text">{{ text() }}</span>
  }

  @if (showRightIcon()) {
    <v-one-icon
      [name]="icon()"
      [type]="iconType()"
      className="v-one-button__icon v-one-button__icon--right"
    />
  }
</button>
